import { Component } from '@angular/core';

@Component({
    selector: 'app-icon-square-pen',
    standalone: true,
    imports: [],
    templateUrl: './icon-square-pen.component.html',
    styleUrl: './icon-square-pen.component.css'
})
export class IconSquarePenComponent { }
